import { useEffect, useState, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    TeamsList
  } from '../../utils'
import { Client, Account, Teams, Functions } from "appwrite";
import logo from "../../assets/tom-logo-icon-black.jpg"

import Popup from '../../components/Popup'
import { createUser } from '../../appwrite/methods'
import DashboardMenu from '../../components/DashboardMenu.jsx'
import Skeleton from '@mui/material/Skeleton';
import { Query } from 'appwrite'
import ThemeOption from '../../components/ThemeOption.jsx'
import LogoLoader from '../../components/LogoLoader';

import { PageContainer } from '@toolpad/core/PageContainer';
import Grid from '@mui/material/Grid2';
import { OutlinedCard } from '../../components/OutlinedCard.jsx';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Avatar from '@mui/material/Avatar';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';

import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);
const teams = new Teams(client);
const functions = new Functions(client);


const columns = [
    { field: 'id', headerName: 'ID', width: 50 },
    {
        field: 'avatar',
        headerName: 'Avatar',
        width: 75,
        editable: false,
    },
    {
        field: 'name',
        headerName: 'Username',
        width: 150,
        editable: true,
    },
    {
        field: 'email',
        headerName: 'Email',
        width: 250,
    },
    {
        field: 'team',
        headerName: 'Teams',
        width: 200,
        editable: true,
    },
    // TODO: permissions need to be handled on a per team basis; thus, this functionality should be moved into a different component
    // {
    //     field: 'permissions',
    //     headerName: 'Permissions',
    //     type: 'singleSelect',
    //     valueOptions: ['Admin'],
    //     width: 150,
    //     editable: true,
    // },
    // For info purposes
    // {
    //   field: 'fullName',
    //   headerName: 'Full name',
    //   description: 'This column has a value getter and is not sortable.',
    //   sortable: false,
    //   width: 160,
    //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    // },
];


export default function Admin() {
    const navigate = useNavigate()
    const [userSession, setUserSession] = useAtom(UserSession);
    const [teamsList, setTeamsList] = useAtom(TeamsList);
    const [rows, setRows] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [showLoadingScreen, setShowLoadingScreen] = useState(false);

    // Display loading screen while the page loads
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowLoadingScreen(true);
        }, 50);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
        }, 0);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    if (isLoading && showLoadingScreen) return <LogoLoader />;

    return (<DashboardMenu path="" user={userSession} needsMaster={true} page={userSession && (<div className="page-content">
        <Typography variant="h4" gutterBottom>
            Admin Panel
        </Typography>
        <Grid container spacing={2} sx={{ mt: 3 }}>
            <Grid size={6}>
                <Card>
                    <CardActionArea onClick={() => navigate('/admin/users')} sx={{ p: 2 }}>
                        <PeopleAltOutlinedIcon sx={{ width: '25%', height: '25%', maxWidth: '150px', color: 'primary.main', display: 'flex', m: 'auto', mt: 2, mb: -1}}/>
                        <CardContent>
                            <Typography gutterBottom variant="h2" component="div" sx={{ fontSize: 42 }}>
                                Users
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                View information on all users such as emails, associated teams, online status, and more.
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            <Grid size={6}>
                <Card>
                    <CardActionArea onClick={() => navigate('/admin/teams')} sx={{ p: 2 }}>
                        <CorporateFareOutlinedIcon sx={{ width: '25%', height: '25%', maxWidth: '150px', color: 'primary.main', display: 'flex', m: 'auto', mt: 2, mb: -1}}/>
                        <CardContent>
                            <Typography gutterBottom variant="h2" component="div" sx={{ fontSize: 42 }}>
                                Teams
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                View information on individual teams such as user permissions, available widgets, and more.
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
        </Grid>
    </div>)} />)
}